import React, { useState, useEffect, useRef } from 'react';
import DashboardNav from '../../Components/Navigation.js/Navigation';
import Horheader from '../../Components/horheader/horheader';
import { FaHourglassHalf } from "react-icons/fa";
import classes from './AllApplications.module.css';
import { FaCircleCheck } from "react-icons/fa6";
import { FaCheckSquare } from "react-icons/fa";
import { GiTakeMyMoney } from "react-icons/gi";
import { Spinner, Badge, Modal, Form, Tabs, Tab, Placeholder, PlaceholderButton } from 'react-bootstrap';
import {
  Pagination,
  Accordion,
} from "react-bootstrap";
import PaidIcon from '../../Asset/PaidIc.png';
import MakePaymentIcon from '../../Asset/wallet.png';
import PendingPaymentIcon from '../../Asset/Pending.png';
import NotPaidPaymentIcon from '../../Asset/Notpaid.png';
import MoreIcon from '../../Asset/more.png';
import search from "../../Asset/search.svg";
import Calender from "../../Asset/calendar.svg";
import Printer from '../../Asset/printer.png';
import xport from "../../Asset/export.png";
import Chart from "../../Components/Chart";
import DownloadIcon from '../../Asset/download.png';
import TrackIcon from '../../Asset/track.png';
import ContactIcon from '../../Asset/support.png';
import Card from "../../Components/Card";
import ViewIcon from "../../Asset/eye.png";
import notransaction from '../../Asset/no-transaction-icon.svg';
import { Link, useNavigate } from 'react-router-dom';
import featured from '../../Asset/Featured icon.png';
import featuredtwo from '../../Asset/4.png';
import plus from '../../Asset/plus.png';
import PdfIcon from "../../Asset/pdf.svg";
import TotalIcon from '../../Asset/1.png';
import PendingIcon from '../../Asset/3.png';
import { Navbar, Container, Button } from 'react-bootstrap';
import { Row, Col } from "react-bootstrap";
// import localforage from 'localforage';
// import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { BASE_URL } from '../../API/Api';
import Notification from '../../Components/Notification/Notification';
import { useTheme } from '../../ThemeContext';
import Alert from "react-bootstrap/Alert";
import Green from "../../Asset/tick-circle.png";
import hourGlass from "../../Asset/hourglassjpg.jpg";
import Services from "../../Asset/service.png";
// import axios from 'axios';
// import AsyncStorage from '@react-native-async-storage/async-storage';

const AllApplications = () => {
  const [show, setShow] = useState(false);
  const [useType,setUseType] = useState(false)
  const [buildingArea,setBuildingArea] = useState(false)
    const [totalAmountPaid, setTotalAmountPaid] = useState('');
  const [type,setType] = useState(false)
  const [selectedFile3, setSelectedFile3] = useState("");
  const [showRatification, setShowRatification] = useState(false);
  const [showPermit, setShowPermit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShow(false);
  const [customer, setCustomer] = useState([]);
  const handleCloseModal = () => setShowModal(false);
  const [sizePlot,setSizePlot] = useState("")
  const [sizeSqm,setSizeSqm] = useState("")
  const handleShow = () => setShow(true);
  const [tableData1, setTableData1] = useState([]);
  const [bearer, setBearer] = useState('');
  const [roless, setRoless] = useState([]);
  const [totalCompleted, setTotalCompleted] = useState('');
  const [totalApplications, setTotalApplications] = useState('');
  const [totalPending, setTotalPending] = useState('');
  const [name, setName] = useState('');
  const [isFilled, setIsFilled] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [clockTime, setClockTime] = useState(false);
  const [personal, setPersonal] = useState({});
  const handleCloseRatification = () => setShowRatification(false);
  const handleClosePermit = () => setShowPermit(false);
  const [show50, setShow50] = useState(false);
  const handleClockTime = () => {
    setClockTime(!clockTime);
  }
  const [foundInvoice, setFoundInvoice] = useState([]);
  const [foundInvoiceID, setFoundInvoiceID] = useState("");
  const [roleList,setRoleList] = useState("")

  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState("");
  const [benLoading, setBenLoading] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();
  const [surveyPlan,setSurveyPlan] = useState("")
  const [buildingPlan,setBuildingPlan] = useState("")
  const [titleDocument,setTitltDocument] = useState("")
  const [mechanicalPlan,setMechanicalPlan] = useState("")
  const [electricalPlan,setElectricalPlan] = useState("")
  const [structuralPlan,setStructuralPlan] = useState("")

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const formatDateForComparison = (dateString) => {
    return new Date(dateString).toISOString().split("T")[0];
  };
  const filteredData = tableData.filter((item) => {
    const matchesDate = selectedDate
      ? formatDateForComparison(item.created_at) === selectedDate
      : true;
  
      const matchesSearch = searchTerm.trim()
      ? item?.apptype?.description.toLowerCase().trim().includes(searchTerm.toLowerCase().trim())
      : true;
  
    return matchesDate && matchesSearch; // Both conditions must be met
  });
  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);
  const totalPages = Math.ceil(tableData.length / entriesPerPage);
  const [visibleDropdown, setVisibleDropdown] = useState(null);
  const [showUploadTCC, setShowUploadTCC] = useState(false);
  const [applicationDocs, setApplicationDocs] = useState([]);
  const [payment, setPayment] = useState([]);
  const dropdownRef = useRef(null);

  const handleMoreClick = (id) => {
    setVisibleDropdown((prev) => (prev === id ? null : id));
  };

  const handleShowTCC = () => {
    setShowUploadTCC(true);
  };



  const readData = async () => {
    try {
      const detail = await localStorage.getItem('userName');
      const detail1 = await localStorage.getItem('firstName');
      const detail2 = await localStorage.getItem('secondName');
      const details = await localStorage.getItem('userToken');
      const detailss = await localStorage.getItem('isFilledState');


      if (detail !== null) {
        // const firstName = detail.split(' ')[0];
        setName(detail);

      }


      if (details !== null) {
        setBearer(details);
      }
      if (detail1 !== null) {
        setFirstName(detail1);
      }
      if (detail2 !== null) {
        setLastName(detail2);
      }

      if (detailss !== null) {
        setIsFilled(detailss);
      }

 
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

 

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${bearer}`,
  };



  const fetchDashboardData = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/applicant/applications`,
        { headers }
      );
      const results = response.data?.data;
      const resultx = response.data?.data?.completed_applications;
      const resultxx = response.data?.data?.pending_applications;
      const resultxxx = response.data?.data?.total_applications;
      console.log(response?.data?.data);
      setTableData(results);
      setTotalCompleted(resultx);
      setTotalPending(resultxx);
      setTotalApplications(resultxxx);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // navigate('/applications');
      } else {
        let errorMessage = "An error occurred. Please try again.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            // toast.error(errorMessage)
            console.log(errorMessage);
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchDashboardData();
    }
  }, [bearer]);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setVisibleDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handleMoreClick = (rowId) => {
  //   setVisibleDropdown(visibleDropdown === rowId ? null : rowId);
  // };


  const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };


  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const toSentenceCase = (name) => {
    if (!name) return '';

    // Check if the name is already in sentence case
    const isSentenceCase = name.split(' ').every(word =>
      word.charAt(0) === word.charAt(0).toUpperCase() &&
      word.slice(1) === word.slice(1).toLowerCase()
    );

    if (isSentenceCase) {
      return name;
    }

    // Convert to sentence case
    return name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const fetchData1 = async (id) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/applicant/application/details`, {
        headers,
        params: { id },
      });
      console.log(response?.data?.data)
    setUseType(response?.data?.data[0]?.building_plan?.u_type?.description)
    // setBuildingArea(response?.data?.dat)
     setType(response?.data?.data[0]?.building_plan?.type?.description)
     console.log(response?.data?.data[0]?.building_plan?.type?.description,"Getting the type")
     setSizePlot(response?.data?.data[0]?.building_plan?.size_in_plot)
     setSizeSqm(response?.data?.data[0]?.building_plan?.size_in_sqm )
     setSurveyPlan(response?.data?.data[0]?.building_plan?.survey_plan)
     setBuildingPlan(response?.data?.data[0]?.building_plan?.building_plan)
     setElectricalPlan(response?.data?.data[0]?.building_plan?.electrical_plan)
     setMechanicalPlan(response?.data?.data[0]?.building_plan?.mechanical_plan)
     setStructuralPlan(response?.data?.data[0]?.building_plan?.structural_engineering)
     setTitltDocument(response?.data?.data[0]?.building_plan?.title_document)
     console.log(response?.data?.data[0]?.building_plan?.survey_plan)
      const roleList = response.data?.data[0];
      const customer = response.data?.data[0]?.customer;
      const customerTyp = response.data?.data[0]?.customer?.user_type;
      const applicationdocs = response.data?.data[0]?.application_document;
      const payment = response.data?.data[0]?.payment;
      console.log(roleList, ".LLSKKS");
      setRoleList(roleList)
      setCustomer(customer)
    
   
    } catch (error) {
      if (error.response && error.response.status === 401) {
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setRoless([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fullName = `${toSentenceCase(firstName)} ${toSentenceCase(lastName)}`;
  const truncatedName = fullName.length > 17 
    ? fullName.split(" ").reduce((acc, word) => {
        return acc.length + word.length <= 17 ? acc + " " + word : acc;
      }, "").trim() + "..."
    : fullName;

    const handleEyeClick = async (id, appType) => {
      console.log(appType);
      const foundInvoice = tableData.find((item) => item.id === id);
      setFoundInvoiceID(id);
      setFoundInvoice(foundInvoice);
  
      await fetchData1(id);
  
      // setShow20(true);
      if (appType === "Land Allocation") {

      } 
      else if ( appType === "Planning Permit" ) {
        setShowPermit(true)
      }
      else {
        // setShow20(true);
      }
    };

    const handleShow50 = () => {
      setShow50(true);
    };

    const openFileInModal = (fileUrl) => {
      if (fileUrl) {
        setSelectedFile3(fileUrl);
        setShowModal(true);
      } else {
        console.error("Invalid file URL");
        alert("File not available.");
      }
    };
    const handlePrintInvoice = (item) => {
      const foundUser = tableData1.find((items) => items.id === item.id);
      console.log(foundUser)
      if (item.description.includes("INVOICE FOR APPLICATION")) {
        navigate('/invoice_print', { state: { item,userData: foundUser } });
      }
      else if(item.description.includes("INVOICE FOR ASSESSMENT")) {
        navigate('/print_letter_of_assessment', { state: { item,userData: foundUser } });
      }
      // const selectedInvoice = tableData.find(items => items.id === item.id);
      // navigate('/accounting/customers_receiptssss', { state: { selectedInvoice } });
    };
  
    const handleDateChange = (e) => {
      setSelectedDate(e.target.value)
    }

    const exportToCSV = () => {
      if (tableData.length === 0) {
        alert("No data available for export.");
        return;
      }
    
      // Define CSV Headers
      const headers = ["S/N", "Application Number", "Application Type", "Submission Date", "Application Status", "Payment Status"];
    
      // Map the data to match CSV format
      const csvData = tableData.map((item, index) => ({
        "S/N": index +  1 || "N/A",
        "Application Number": item.uuid || "N/A",
        "Application Type": item.apptype?.description || "N/A",
        "Submission Date": formatDate(item.created_at) || "N/A",
        "Application Status": item.approval_status === 0 ? "Ongoing" : "Completed" || "N/A",
        "Payment Status": item.payment_status === "0" ? "Unpaid" : "Paid" || "N/A",
      }));
    
      // Convert to CSV format
      const csv = Papa.unparse({ fields: headers, data: csvData });
    
      // Create a Blob for download
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "Applications.csv");
    };


  return (
    <>
         <Modal
              show={showPermit}
              onHide={handleClosePermit}
              size="lg"
              centered
            >
              <Modal.Header>
                <Modal.Title
                  style={{
                    fontSize: 18,
                    color: "#333333",
                    fontWeight: 500,
                  }}
                >
                  Application Details
                </Modal.Title>
                <Button
                  variant="close"
                  onClick={handleClosePermit}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Accordion
                  defaultActiveKey="1"
                  style={{ paddingBottom: "30px" }}
                >
                  <Accordion.Item eventKey="1">
                    <Accordion.Header
                      style={{
                        maxWidth: "900px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Application Details
                    </Accordion.Header>
                    <Accordion.Body>
                      {roless.status !== "1" && (
                        <div className={classes.divUpdate}>
                          {/* <button className={classes.updateBtn}>
                            Update Application
                          </button> */}
                        </div>
                      )}

                      <table className="table m-0 bg-white display table-bordered table-striped table-hover card-table">
                        <tbody style={{ whiteSpace: "nowrap" }}>
                          {/* <tr>
                            <th style={{ width: "50%" }}>Application Number</th>
                            <td style={{ width: "50%" }}>
                              {roless.application_number}
                            </td>
                          </tr> */}
                       
                          <tr>
                            <th>Land Use Type</th>
                            <td>{useType}</td>
                          </tr>
                          <tr>
                            <th>Building Area/Location</th>
                            {/* <td>{useType}</td> */}
                          </tr>
                          <tr>
                            <th>Type</th>
                            <td>{type}</td>
                          </tr>
                          <tr>
                            <th>Size in plot</th>
                            <td>{sizePlot}</td>
                          </tr>
                          <tr>
                            <th>Size in Sqm </th>
                            <td>{sizeSqm}</td>
                          </tr>
                        </tbody>
                      </table>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header
                      style={{
                        maxWidth: "900px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Uploaded Documents
                    </Accordion.Header>
                    <Accordion.Body>
                    <h5>Survey Plan</h5>
                    
                      <iframe
                              src={surveyPlan}
                              width="100%"
                              height="500px"
                              style={{ border: "none" }}
                              title="Survey Plan"
                            ></iframe>
                    <h5>Building Architectural Plan</h5>
                      <iframe
                              src={buildingPlan}
                              width="100%"
                              height="500px"
                              style={{ border: "none" }}
                              title="Survey Plan"
                            ></iframe>
                    <h5>Electrical Architectural Plan </h5>
                      <iframe
                              src={electricalPlan}
                              width="100%"
                              height="500px"
                              style={{ border: "none" }}
                              title="Survey Plan"
                            ></iframe>
                    <h5>Mechanical Architectural Plan </h5>
                      <iframe
                              src={mechanicalPlan}
                              width="100%"
                              height="500px"
                              style={{ border: "none" }}
                              title="Survey Plan"
                            ></iframe>
                    <h5>Structural Architectural Plan </h5>
                      <iframe
                              src={structuralPlan}
                              width="100%"
                              height="500px"
                              style={{ border: "none" }}
                              title="Survey Plan"
                            ></iframe>
                    <h5>Title Document</h5>
                      <iframe
                              src={titleDocument}
                              width="100%"
                              height="500px"
                              style={{ border: "none" }}
                              title="Survey Plan"
                            ></iframe>
                   
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header
                      style={{
                        maxWidth: "900px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      GIS Details
                    </Accordion.Header>
                    <Accordion.Body>No data</Accordion.Body>
                  </Accordion.Item>

                  <div className={classes.formIntBtn}>
                    {/* {shouldShowAlert && !showAlert && ( */}
                    <Alert variant="warning" className="w-100">
                      <Alert.Heading>Requirement Checklist</Alert.Heading>
                      {/* <p>
                          The application is missing the following required
                          fields:
                        </p> */}
                      <ul style={{ listStyleType: "none", padding: 0 }}>
                        <li style={{ color: customer?.tin ? "green" : "red" }}>
                          {customer?.tin ? "✔" : "❌"} STIN (State Tax
                          Identification Number)
                        </li>
                        {customer?.user_type === "corporate" && (
                          <li style={{ color: customer?.cac ? "green" : "red" }}>
                            {customer?.cac ? "✔" : "❌"} CAC
                          </li>
                        )}
                        {customer?.user_type === "individual" && (
                          <li style={{ color: customer?.nin ? "green" : "red" }}>
                            {customer?.nin ? "✔" : "❌"} NIN (National
                            Identification Number)
                          </li>
                        )}
                        <li style={{ color: customer?.tcc ? "green" : "red" }}>
                          {customer?.tcc ? "✔" : "❌"} Tax Clearance Certificate
                          {customer?.ogun_resident === "No" && !customer.tcc && (
                            <span
                              className={classes.tccStyle}
                              onClick={handleShowTCC}
                            >
                              Click here to upload TCC
                            </span>
                          )}
                        </li>
                      </ul>
                    </Alert>
                    {/* / )} */}
                  </div>
                  <Tabs
                    defaultActiveKey="invoicesandreceipts"
                    id="uncontrolled-tab-example"
                    className="mb-3 confirm-tabs "
                    variant="underline"
                    color="white"
                    style={{ marginTop: "15px", textDecoration: "none" }}
                  >
                    <Tab
                      eventKey="invoicesandreceipts"
                      title="Invoices and Receipts"
                    >
                      <div className="w-100" style={{ margin: "20px 0 0 0" }}>
                        <div className={classes.formIntBtn12}>
                          <h5>Invoices & Receipts</h5>
                        </div>
                        <table className="table m-0 bg-white display table-bordered table-striped table-hover card-table">
                          <thead style={{ whiteSpace: "nowrap" }}>
                            <tr>
                              <th>S/N</th>
                              <th>Description</th>
                              <th>Transaction Date</th>
                              <th>Payment Code</th>
                              <th>Status</th>
                              <th>Amount</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody style={{ whiteSpace: "nowrap" }}>
                            {payment.map((item, index) => {
                              return (<tr key={index}>
                                <td>{index + 1}</td>
                                <td style={{ whiteSpace: "wrap" }}>
                                  {item.description}
                                </td>
                                <td>
                                  {new Date(item.created_at).toLocaleString(
                                    "en-US",
                                    {
                                      year: "numeric",
                                      month: "2-digit",
                                      day: "2-digit",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    }
                                  )}
                                </td>
                                <td>{item.payment_code}</td>
                                <td
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  {item.status === "1" ? (
                                    <div
                                      style={{
                                        height: 15,
                                        width: 70,
                                        border: "1px solid #50b848",
                                        borderRadius: 3,
                                        color: "#50b848",
                                        fontSize: 10,
                                        textAlign: "center",
                                        fontWeight: 700,
                                      }}
                                    >
                                      PAID
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        height: 15,
                                        width: 70,
                                        border: "1px solid #ff5400",
                                        borderRadius: 3,
                                        color: "#ff5400",
                                        fontSize: 10,
                                        textAlign: "center",
                                        fontWeight: 700,
                                      }}
                                    >
                                      UNPAID
                                    </div>
                                  )}
                                </td>
                                <td>
                                  {parseFloat(item.amount).toLocaleString(
                                    "en-US",
                                    {
                                      minimumIntegerDigits: 1,
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </td>
                                <td>
                                <div onClick={() => handlePrintInvoice(item)} className="btn btn-sm printbtninv">
                                <i className="fa fa-print dawg" style={{ color: "#17a2b8", backgroundColor: "#afe1e9", padding: 2, borderColor: "#b0d1d6", borderRadius: 5, fontSize: 12 }}></i>
                              </div>
                                </td>
                              </tr>)
                            })}
                          </tbody>
                        </table>
                      </div>
                    </Tab>
                    <Tab eventKey="documents" title="Documents">
                      <div className="w-100" style={{ margin: "20px 0 0 0" }}>
                        <div className={classes.formIntBtn12}>
                          <h5>Uploaded Document</h5>
                          <Button
                            variant="success"
                            className={classes.btn1}
                            onClick={handleShow50}
                          >
                            Add New Document
                          </Button>
                        </div>
                        {applicationDocs.length > 0 && (
                          <Container>
                            {applicationDocs
                              .reduce((rows, item, index) => {
                                if (index % 2 === 0) {
                                  rows.push([]);
                                }
                                rows[rows.length - 1].push(item);
                                return rows;
                              }, [])
                              .map((row, rowIndex) => (
                                <Row key={rowIndex} className="mb-3">
                                  {row.map((item, index) => (
                                    <Col key={index} lg={6}>
                                      <p>{item.description}</p>
                                      <div className={classes.pdfTablem}>
                                        <div className={classes.pdfTableL}>
                                          <img
                                            src={PdfIcon}
                                            alt="icon"
                                            className={classes.pdfIcon}
                                          />
                                          <span>
                                            {item.document_path
                                              ? item.document_path
                                                  .split("/")
                                                  .pop().length > 30
                                                ? item.document_path
                                                    .split("/")
                                                    .pop()
                                                    .substring(0, 30) + "..."
                                                : item.document_path
                                                    .split("/")
                                                    .pop()
                                              : "No File"}
                                          </span>
                                        </div>
                                        <div
                                          className={classes.pdfTableR}
                                          onClick={() =>
                                            openFileInModal(item.document_path)
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          <p>
                                            {" "}
                                            View{" "}
                                            <span>
                                              <img
                                                src={DownloadIcon}
                                                alt="Download icon"
                                                className={classes.downloadIcon}
                                              />
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </Col>
                                  ))}
                                </Row>
                              ))}
                          </Container>
                        )}
                      </div>
                    </Tab>
                  </Tabs>
                </Accordion>
              </Modal.Body>
            </Modal>
      <div className={classes.appcontainer}>
        <div className={classes.sidenav}>
          <Navbar expand="lg" className={`d-none d-md-block ${classes.navbar}`}>
            <Container fluid>
            </Container>
          </Navbar>
          <Navbar bg="light" expand={false} className={`d-md-none ${classes.bglight}`}>
            <Container fluid>
              <Button classes={{ backgroundColor: "#21B55A", border: "none" }} variant="success" onClick={handleShow}>
                ☰
              </Button>
            </Container>
          </Navbar>
          <DashboardNav show={show} handleClose={handleClose} />
        </div>

        <div className={classes.maincontent}>

          <div className={classes.mobileHeader}>
            <Horheader />
          </div>
          <div className={classes.dashBoardCont}>
            <div className={classes.usrwlcm}>
              <div className={classes.wlcmcont}>
                <p classes={{ color: isDarkMode ? "white" : "#101828", fontWeight: 600, fontSize: 30 }} className={classes.wlcm}>Services</p>
               <p style={{marginTop: "-15px"}}>Your Hub for All Services – Apply, Track, and Stay Updated.</p>
              </div>
              <button onClick={() => setShowModal(true)} className={classes.btnadd}><img src={plus} className={classes.plusiconstyl} />
                <span> Make New Application</span>
              </button>
            </div>

            <Modal
              show={showModal}
              onHide={handleCloseModal}
              size="lg"
              centered
            >
              <Modal.Header>
                <Modal.Title
                  style={{
                    fontSize: 18,
                    color: "#333333",
                    fontWeight: 500,
                  }}
                >
                  Services Offered by MPPUD
                </Modal.Title>
                <Button variant="close" onClick={handleCloseModal}></Button>
              </Modal.Header>
              <Modal.Body>
                <div className={classes.crdCont}>
                 <div
                                     
                                      className={classes.card}
                                    >
                                      
                                        <div>
                                          <h3
                                            className={classes.cardTitle}
                                            style={{ wordWrap: "break-word" }}
                                          >
                                            Building Permit Application
                                          </h3>
                                        </div>
                                   
                                      <p
                                        className={classes.textPrg}
                                        style={{ wordWrap: "break-word" }}
                                      >
                                        Click the Apply Button to start your application
                                      </p>
                                      <div className={classes.bottomBtn}>
                                        <Button
                                          onClick={() =>
                                            navigate('/applications_building_permit')
                                          }
                                          variant="success"
                                          className={classes.appBtn}
                                        >
                                          Apply
                                        </Button>
                                      </div>
                                    </div>
                                    </div>
              </Modal.Body>
            </Modal>


            <div className={classes.allcards}>
              <div className={classes.card_rd}>
                <div className={classes.card1}>
                  {" "}
                  <div className={classes.onekad}>
                  <img src={Services} className={classes.piccards} alt="green icon" />
                  {/* <FaCircleCheck  color='#092e5b' size={50}/> */}
                <div className={classes.onekadfrstp}>
                  {/* <FaMoneyBillTrendUp color='white' size={40}/> */}
                  {/* <img src={featured} className={classes.featuredicon} /> */}
                  <p className={classes.walltp}>Total Services</p>
                  <p className={classes.walltpm}>

                    {benLoading ? (
                      <Placeholder animation="glow">
                        <Placeholder xs={12} />
                      </Placeholder>
                    ) : (
                      `100
                      `
                    )}

                  </p>
                </div>

              </div>
                   <div className={classes.onekad}>
                   <img src={hourGlass} className={classes.hoursglass} alt="hourglass icon" />
                  {/* <FaHourglassHalf   color='#092e5b' size={50}/> */}
                <div className={classes.onekadfrstp}>
                  {/* <FaMoneyBillTrendUp color='white' size={40}/> */}
                  {/* <img src={featured} className={classes.featuredicon} /> */}
                  <p className={classes.walltp}>Pending Services</p>
                  <p className={classes.walltpm}>

                    {benLoading ? (
                      <Placeholder animation="glow">
                        <Placeholder xs={12} />
                      </Placeholder>
                    ) : (
                      `50`
                    )}

                  </p>
                </div>

              </div>
                </div>
                <div className={classes.card2}>
                  {" "}
                  {/* <Card title="Total Amount Utilized" amount={'00,000,000'} /> */}
                  <div className={classes.onekad}>
                  <img src={Green} className={classes.piccards} alt="green icon" />
                  {/* <FaCircleCheck  color='#092e5b' size={50}/> */}
                  {/* <FaCheckSquare    color='#092e5b' size={50}/> */}
                <div className={classes.onekadfrstp}>
                  {/* <FaMoneyBillTrendUp color='white' size={40}/> */}
                  {/* <img src={featured} className={classes.featuredicon} /> */}
                  <p className={classes.walltp}>Total Completed Services</p>
                  <p className={classes.walltpm}>

                    {benLoading ? (
                      <Placeholder animation="glow">
                        <Placeholder xs={12} />
                      </Placeholder>
                    ) : (
                      `50`
                    )}

                  </p>
                </div>

              </div>
                </div>
              </div>
              {/* <div className={classes.chartSection}>
                <Chart />
              </div> */}

            </div>


            {/* Table container starts here */}

            <div className={isDarkMode ? classes.applicationHistory1 : classes.applicationHistory}>
              <div className={classes.hortrstns}>
              <h1 className={classes.recenttrsd}>My Applications</h1>
              <div className={classes.midDiv}>
                <div className={classes.divSearch}>
                  <img src={search} alt="search" className={classes.searchIcon} />
                  <input
                  value={searchTerm}
                    type="text"
                    placeholder="Search"
                    className={classes.search}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                    }}
                    
                  />
                  {searchTerm && (
      <button 
        onClick={() => setSearchTerm('')}
        style={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#000'
        }}
      >
        ×
      </button>
      )}
                </div>
                {/* <Form.Select
                  id='status'
                  style={{
                   
                    height: 40,
                    borderRadius: 8,
                    fontSize: 12,
                    border: '1px solid #E0E0E0',
                    fontWeight: 400,
                    color: '#4F4F4F',
                    padding: '0.5rem',
                   
                  }}
                  name="DataTables_Table_0_length"
                  aria-controls="DataTables_Table_0"
                  className="custom-select custom-select-sm form-control form-control-sm"
                >
                  <option value="">Select Status</option>
                  <option value="0">Ongoing</option>
                  <option value="1">Completed</option>
                </Form.Select> */}



                <input 
  type="date" 
  className={classes.bttens} 
  onChange={handleDateChange} name="date" value={selectedDate}
/>

                <label
                  style={{
                    fontSize: 14,
                    color: " #828282",
                    fontWeight: 600,
                    gap: 10,
                    borderRadius: 8,
                    // backgroundColor: '#F2F2F2',
                    marginLeft: 10
                  }}

                >

                  <div className={classes.divBtn}>
                    <div className={classes.divOne}>
                      <div onClick={exportToCSV} className={classes.stIC}>
                        <p className={classes.stN}>Export CSV</p>
                        <img src={xport} alt="status" className={classes.filter} />
                      </div>
                    </div>
                  </div>


                </label>

              </div>
            </div>

              <div className={classes.mainTables}>
                {benLoading ? (
                  <>
                    <Placeholder xs={6} />
                    <Placeholder className="w-75" /> <Placeholder classes={{ width: '25%' }} />
                  </>
                  
                ) : currentEntries.length === 0 ? (
                  <div className={classes.notFound}>
                    <img src={notransaction} alt="not-found" />
                    <p>No Applications found</p>
                  </div> 
                 ) : ( 
                  <div >
                    <table style={{ width: "98%" }}>

                      <thead style={{ whiteSpace: 'wrap' }}>
                        <tr>
                          <th style={{ color: isDarkMode && "white" }}>S/N</th>
                          <th style={{ color: isDarkMode && "white" }}>Application Number</th>
                          <th style={{ color: isDarkMode && "white" }}>Application Type</th>
                          <th style={{ color: isDarkMode && "white" }}>Application Date</th>
                          <th style={{ color: isDarkMode && "white" }}>Application Status</th>
                          <th style={{ color: isDarkMode && "white" }}>Payment Status</th>
                          <th style={{ color: isDarkMode && "white" }}>Approval Required by</th>
                          {/* <th classes={{ color: isDarkMode && "white" }}>Amount</th> */}
                          <th></th>
                        </tr>
                      </thead>

                      <tbody style={{ whiteSpace: "wrap" }}>
                    {currentEntries.map((rowId, index) => (
                      <tr key={rowId} style={{
                        backgroundColor: index % 2 !== 0 ? "rgba(30, 165, 82, 0.1)" : "transparent",
                      }}>
                        <td style={{ padding: 10 }}>{index + 1}</td>
                        <td style={{ padding: 10 }}>{rowId.uuid}</td>
                        <td style={{ padding: 10 }}>{rowId.apptype?.description}</td>
                        <td style={{ padding: 10 }}>{formatDate(rowId.created_at)}</td>
                        <td style={{ padding: 10 }}>{rowId.approval_status === 0 ? "Ongoing" : "Completed"}</td>
                        <td style={{ padding: 10 }}>{rowId.payment_status === "0" ? "Unpaid" : "Paid"}</td>
                        <td style={{ padding: 10 }}>{rowId.payment_status === "0"
                                    ? "Awaiting your Payment"
                                    : rowId.payment_status === "1" &&
                                      rowId.approval_status === "0"
                                    ? rowId.role?.name
                                    : rowId.payment_status === "1" &&
                                    rowId.approval_status === "1"
                                  ? "Approved"
                                    : null}</td>
                        {/* <td style={{ padding: 10 }}>₦528,861.00</td> */}
                        <td style={{ padding: 10 }} className={classes.moreTxt}>
                          <div style={{ position: "relative" }} className={classes.menuWeb}>
                            <img
                              className={classes.moreIcon}
                              src={MoreIcon}
                              alt="more"
                              onClick={() => handleMoreClick(rowId)}
                              style={{ cursor: "pointer" }}
                            />
                            {visibleDropdown === rowId && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  right: 0,
                                  backgroundColor: "white",
                                  zIndex: 9999,
                                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                  borderRadius: "4px",
                                }}
                              >
                                <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "5px 10px",
                                                cursor: "pointer",
                                                textAlign: "left",
                                                whiteSpace: "nowrap"
                                              }}
                                              
                                            >
                                              <img
                                                src={Printer}
                                                alt="invoice"
                                                style={{
                                                  width: "20px",
                                                  marginRight: "10px",
                                                }}
                                              />
                                              Print Receipt
                                            </div>
                                            <div
      onClick={() => {
        handleEyeClick(rowId.id, rowId?.apptype?.description);
        handleMoreClick(null);
      }}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "5px 10px",
        cursor: "pointer",
         textAlign: "left",
         whiteSpace: "nowrap"
      }}
    >
      <img
        src={ViewIcon}
        alt="view application"
        style={{
          width: "20px",
          marginRight: "10px",
        }}
      />
      View Application
    </div>

                              </div>
                            )}
                          </div>
                        </td>
                      
                      </tr>
                    ))}
                  </tbody>
                    </table>
                  </div>
                 )} 
              </div>

              <div className={classes.mobileView}>
                <div className={classes.mainTable}>
                  {benLoading ? (
                    <p>Loading data, Please wait...</p>
                  ) : (
                    <div
                      className={classes.tableCon}
                      style={{
                        overflowX: "auto", // Horizontal scroll for table
                        whiteSpace: "nowrap", // Prevent table from wrapping
                        maxWidth: "100%", // Limit container width to screen size

                      }}
                    >
                      <table
                        className="table display table-hover m-0 card-table"
                        style={{
                          minWidth: "600px", // Minimum table width to ensure visibility
                        }}
                      >
                        <thead>
                          <tr>
                          <th style={{ color: isDarkMode && "white" }}>S/N</th>
                          <th style={{ color: isDarkMode && "white" }}>Application Number</th>
                          <th style={{ color: isDarkMode && "white" }}>Application Type</th>
                          <th style={{ color: isDarkMode && "white" }}>Submission Date</th>
                          <th style={{ color: isDarkMode && "white" }}>Application Status</th>
                          <th style={{ color: isDarkMode && "white" }}>Payment Status</th>
                          <th style={{ color: isDarkMode && "white" }}>Approval Required by</th>
                          {/* <th classes={{ color: isDarkMode && "white" }}>Amount</th> */}
                          <th></th>
                          </tr>
                        </thead>
                        <tbody style={{ whiteSpace: "wrap" }}>
                        {currentEntries.map((rowId, index) => (
                      <tr key={rowId} style={{
                        backgroundColor: index % 2 !== 0 ? "rgba(30, 165, 82, 0.1)" : "transparent",
                      }}>
                        <td style={{ padding: 10 }}>{index + 1}</td>
                        <td style={{ padding: 10 }}>{rowId.uuid}</td>
                        <td style={{ padding: 10 }}>{rowId.apptype?.description}</td>
                        <td style={{ padding: 10 }}>{formatDate(rowId.updated_at)}</td>
                        <td style={{ padding: 10 }}>{rowId.approval_status === 0 ? "Ongoing" : "Completed"}</td>
                        <td style={{ padding: 10 }}>{rowId.payment_status === "0" ? "Unpaid" : "Paid"}</td>
                        <td style={{ padding: 10 }}>{rowId.payment_status === "0"
                                    ? "Awaiting your Payment"
                                    : rowId.payment_status === "1" &&
                                      rowId.approval_status === "0"
                                    ? rowId.role?.name
                                    : rowId.payment_status === "1" &&
                                    rowId.approval_status === "1"
                                  ? "Approved"
                                    : null}</td>
                        {/* <td style={{ padding: 10 }}>₦528,861.00</td> */}
                        <td style={{ padding: 10 }} className={classes.moreTxt}>
                          <div style={{ position: "relative" }} className={classes.menuWeb}>
                            <img
                              className={classes.moreIcon}
                              src={MoreIcon}
                              alt="more"
                              onClick={() => handleMoreClick(rowId)}
                              style={{ cursor: "pointer" }}
                            />
                            {visibleDropdown === rowId && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  right: 0,
                                  backgroundColor: "white",
                                  zIndex: 9999,
                                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                  borderRadius: "4px",
                                }}
                              >
                                <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "5px 10px",
                                                cursor: "pointer",
                                                textAlign: "left",
                                                whiteSpace: "nowrap"
                                              }}
                                              
                                            >
                                              <img
                                                src={Printer}
                                                alt="invoice"
                                                style={{
                                                  width: "20px",
                                                  marginRight: "10px",
                                                }}
                                              />
                                              Print Receipt
                                            </div>
                                            <div
      onClick={() => {
        handleEyeClick(rowId.id, rowId?.apptype?.description);
        handleMoreClick(null);
      }}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "5px 10px",
        cursor: "pointer",
         textAlign: "left",
         whiteSpace: "nowrap"
      }}
    >
      <img
        src={ViewIcon}
        alt="view application"
        style={{
          width: "20px",
          marginRight: "10px",
        }}
      />
      View Application
    </div>

                              </div>
                            )}
                          </div>
                        </td>
                      
                      </tr>
                    ))}
                  </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
              {!benLoading && (
                <div className={classes.endded}>
                  <div className={classes.showTxt}>
                    <div className={classes.show}>
                      <label classes={{
                        fontSize: 14,
                        color: isDarkMode ? '#ffffff' : '#333333',
                        fontWeight: 600,
                        gap: 10
                      }} className="d-flex justify-content-start align-items-center">
                        Showing
                        <Form.Select classes={{ width: 114, height: 44, borderRadius: 8, fontSize: 14, fontWeight: 600 }} name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" className="custom-select custom-select-sm form-control form-control-sm"
                          value={entriesPerPage}
                          onChange={(e) => {
                            setEntriesPerPage(parseInt(e.target.value));
                            setCurrentPage(1);
                          }}
                        >
                          <option value={10} >10 entries</option>
                          <option value={25} >25 entries</option>
                          <option value={50} >50 entries</option>
                          <option value={100} >100 entries</option>
                        </Form.Select>
                      </label>
                    </div>
                  </div>

                  <div className={classes.btmPagination}>
                        <div style={{ display: "flex" }}>
                          <button
                            style={{
                              textAlign: "center",
                              border: "1px solid #F1F1F1",
                              backgroundColor: "#fff",
                              borderRadius: 8,
                              height: "32px",
                              width: "32px",
                              fontWeight: 700,
                              fontSize: 14,
                              color: "#000000",
                              cursor: "pointer",
                            }}
                            onClick={handlePrevPage}
                            disabled={currentPage === 1}
                          >
                            {"<"}
                          </button>
                          {[...Array(totalPages)].map((_, page) => {
                            // Show only 5 pages or less if available
                            if (
                              page < 3 ||
                              page === currentPage - 1 ||
                              page === totalPages - 1
                            ) {
                              return (
                                <button
                                  key={page + 1}
                                  style={{
                                    textAlign: "center",
                                    marginLeft: "0.4rem",
                                    marginRight: "0.4rem",
                                    fontSize: "14px",
                                    fontWeight: 700,
                                    color:
                                      page + 1 === currentPage
                                        ? "#ffffff"
                                        : "#333333",
                                    backgroundColor:
                                      page + 1 === currentPage
                                        ? "#092e5b"
                                        : "#fff",
                                    height: "32px",
                                    borderRadius: "8px",
                                    //   padding: '0.5rem',
                                    border: "1px solid #F1F1F1",
                                    width: "32px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => setCurrentPage(page + 1)}
                                >
                                  {page + 1}
                                </button>
                              );
                            }
                            return null;
                          })}
                          <button
                            style={{
                              textAlign: "center",
                              border: "1px solid #F1F1F1",
                              backgroundColor: "#fff",
                              borderRadius: 8,
                              height: "32px",
                              width: "32px",
                              fontWeight: 700,
                              fontSize: 14,
                              color: "#000000",
                              cursor: "pointer",
                            }}
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages}
                          >
                            {">"}
                          </button>
                        </div>
                      </div>

                </div>
              )}
              {/* <div className={classes.notFound}>
                <img src={notransaction} alt="not-found" />
                <p>No Applications found</p>
                </div> */}
            </div>
 {/* transaction details table  starts here*/}


            {/* Table container ends here */}
          </div>
        </div>
      </div>
    </>
  );
}

export default AllApplications;